const CN_NUMS = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
const CN_INT_RADICE = ['', '拾', '佰', '仟'];
const CN_INT_UNITS = ['', '万', '亿', '兆'];
const CN_DEC_UNITS = ['角', '分'];

function sectionToChinese(section) {
  let str = '';
  let zero = true;
  for (let i = 0; i < 4; i += 1) {
    const n = section % 10;
    section = Math.floor(section / 10);
    if (n === 0) {
      if (!zero) {
        zero = true;
        str = CN_NUMS[n] + str;
      }
    } else {
      zero = false;
      str = CN_NUMS[n] + CN_INT_RADICE[i] + str;
    }
  }
  return str.replace(/^零+/, '');
}

export function amountToChinese(amount) {
  const num = Number(amount);
  if (!Number.isFinite(num)) return '';
  if (num === 0) return '零元整';

  let integer = Math.floor(Math.abs(num));
  let decimal = Math.round((Math.abs(num) - integer) * 100);
  if (decimal === 100) {
    integer += 1;
    decimal = 0;
  }

  let chinese = num < 0 ? '负' : '';
  if (integer > 0) {
    let unitPos = 0;
    let needZero = false;
    while (integer > 0) {
      const section = integer % 10000;
      if (needZero) chinese = CN_NUMS[0] + chinese;
      chinese = sectionToChinese(section) + CN_INT_UNITS[unitPos] + chinese;
      needZero = section < 1000 && section > 0;
      integer = Math.floor(integer / 10000);
      unitPos += 1;
    }
    chinese += '元';
  } else {
    chinese += '零元';
  }

  if (decimal === 0) {
    chinese += '整';
  } else {
    const jiao = Math.floor(decimal / 10);
    const fen = decimal % 10;
    if (jiao > 0) chinese += CN_NUMS[jiao] + CN_DEC_UNITS[0];
    if (fen > 0) chinese += CN_NUMS[fen] + CN_DEC_UNITS[1];
  }
  return chinese;
}
